
export enum TicketType {
  Standard = 'Standard',
  Promoter = 'Promoter',
  Protocol = 'Protocol',
  HardTicket = 'HardTicket',
}

export function getTicketTypeId(ticketType: TicketType): number {
  switch(ticketType) {
    case TicketType.Protocol:
      return 0;
    case TicketType.Standard:
      return 1;
    case TicketType.Promoter:
      return 2;
    case TicketType.HardTicket:
      return 3;
  }
}

export function getTicketTypeShortCode(ticketType: TicketType): string {
  switch(ticketType) {
    case TicketType.Protocol:
      return 'ptc';
    case TicketType.Standard:
    case TicketType.Promoter:
      return 'std';
    case TicketType.HardTicket:
      return 'hrd';
  }
}
